import { ArcElement, BarElement, CategoryScale, ChartDataset, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { InsideTextPlugin } from "components/ChartJsPlugins/insideTextPlugin";
import { Formaters } from 'lib/Formaters';

ChartJS.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    InsideTextPlugin,
    ChartDataLabels
);

export type DashValueMode = "absolute" | "percent";

export type DashValueFormat = "number" | "percentage" | "currency" | "fileSize";

export const ChartColors = {
    Gray: "rgb(127, 127, 127)",
    GrayLight: 'rgb(218, 218, 218)',
    Blue: "rgb(68, 114, 196)",
    Blue35: "rgba(25, 118, 210, 0.35)",
    BlueLight: "rgb(91, 155, 213)",
    Salmon: "rgb(244, 177, 131)",
    Red: "rgb(255, 0, 0)",
    RedLight: "rgb(213, 93, 93)",
    RedDark: "rgb(158, 0, 0)",
    Green: "rgb(28, 186, 110)",
    GreenLight: "rgb(197, 224, 180)",
    GreenDark: "rgb(112, 173, 71)",
    OrangeLight: "rgb(255,210,127)",
    Orange: "rgb(255,165,0)",
    Purple: "rgb(153,51,255)",
    TaxOn: "#81c784",
    TaxOff: "#dadada",
    White: "#fff"
};

export interface DashLabels {
    shortLabel: string;
    longLabel: string;
}

export type DashBarDataset = ChartDataset<"bar", number[]> & {
    id: number;
};

// export type DashDoughnutDataset = ChartDataset<"doughnut", number[]> & {
//     id: number;
// };

export type DashPieDataset = ChartDataset<"pie", DashDoughnutDataType[]>;

export type DashDoughnutDataset = ChartDataset<"doughnut", DashDoughnutDataType[]>;

export type DashDoughnutDataType = {
    id: number;
    values: number[];
    tooltip?: {
        title: string;
        formatedValue: string;
    };
};

export type DashTooltipParam = {
    enabled: boolean;
    valueFormat: DashValueFormat;
};

export function DashFormatValue(value: number, valueFormat: DashValueFormat, currrencySymbol: string | undefined = undefined) {
    return valueFormat == "percentage"
        ? value + "%"
        : valueFormat == "currency"
            ? (currrencySymbol ? currrencySymbol + " " : "") + (value == 0 ? " - " : Formaters.currency(value))
            : valueFormat == "fileSize"
                ? Formaters.fileSize(value)
                : Formaters.localeNumber(value) ?? undefined;

}

export function DashFormatLabel(value: number, valueMode: DashValueMode) {
    return valueMode == "absolute"
        ? Formaters.localeNumber(value)
        : value.toFixed(1) + "%";
}